import SpinnerIcon from "@/assets/icons/app/spinner.svg?react";
import BackDrop from "@/components/atoms/BackDrop";

const FullSceenLoader = () => {
  return (
    <div className="z-[10000] fixed top-0 size-full">
      <BackDrop>
        <SpinnerIcon className="me-3 inline size-10 animate-spin text-primary-600" />
      </BackDrop>
    </div>
  );
};

export default FullSceenLoader;
